<template>
  <b-modal
    :id="id"
    :ok-title="trans('restore')"
    ok-variant="success"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onApply"
  >
    <template #modal-title>
      <div v-if="!!booking">
        {{ trans('booking') }}
        <small class="text-muted ml-2">
          #{{ booking.id }}
        </small>
      </div>
    </template>

    <p>{{ trans('restore') }}?</p>
    <small v-for="(event, index) in events || []" :key="event.id" class="d-block">
      {{ `${event.location_name} @ ${moment(event.start).format('LLL')} - ${moment(event.end).format('LT')}` }}
    </small>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'restore-booking-modal',
      },
      organization: Object,
      booking: Object,
      log: Object,
      index: Number,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
      }
    },
    computed: {
      events() {
        if (!this.index || !this.booking) return []
        return this.booking.log[this.index-1].events
      },
    },
    methods: {
      onShown() {

      },
      onHidden() {
        this.busy = false
        this.error = null
      },
      onApply(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/booking/${this.booking.id}/restore`
        axios.post(url, {log: this.log})
        .then(response => {
          this.busy = false
          this.$bvModal.hide(this.id)
          this.$emit('restored', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window[_.camelCase(this.id)] = this
    },
  }
</script>